module.exports = __webpack_public_path__ + "static/media/jewelry-earrings-gold.498ce600.svg";